// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/fonts/LibreBodoni-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `main {
	display: flex;
	flex-direction: column;
	align-items: center;
	overflow-x: hidden;
	scrollbar-width: none;
	height: 100dvh;
}

a {
	text-decoration: none;
	color: black;
	padding: 0.5rem;
	margin-left: 5px;
	margin-right: 5px;
}

button {
	/* remove default button styles */
	margin: 0;
	background-color: transparent;
	text-align: inherit;
	font: inherit;
	appearance: none;
	border-style: none;
	/* default look */
	padding: 1rem 2.5rem 1rem 2.5rem;
	border-radius: 0.5rem;
	background: rgb(105, 145, 163);
	color: white;
	cursor: pointer;
	font-size: 1.5rem;
}

input {
	padding: 10px;
	font-size: 16px;
	margin: 10px 0;
	width: 100%;
	border: 1px solid #ccc;
	border-radius: 4px;
}

@font-face {
	font-family: 'LibreBodoniBold';
	font-weight: normal;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
	font-style: normal;
	font-display: swap;
}
`, "",{"version":3,"sources":["webpack://./src/styles.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,kBAAkB;CAClB,qBAAqB;CACrB,cAAc;AACf;;AAEA;CACC,qBAAqB;CACrB,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,iCAAiC;CACjC,SAAS;CACT,6BAA6B;CAC7B,mBAAmB;CACnB,aAAa;CACb,gBAAgB;CAChB,kBAAkB;CAClB,iBAAiB;CACjB,gCAAgC;CAChC,qBAAqB;CACrB,8BAA8B;CAC9B,YAAY;CACZ,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,cAAc;CACd,WAAW;CACX,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,8BAA8B;CAC9B,mBAAmB;CACnB,+DAAmE;CACnE,kBAAkB;CAClB,kBAAkB;AACnB","sourcesContent":["main {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\talign-items: center;\r\n\toverflow-x: hidden;\r\n\tscrollbar-width: none;\r\n\theight: 100dvh;\r\n}\r\n\r\na {\r\n\ttext-decoration: none;\r\n\tcolor: black;\r\n\tpadding: 0.5rem;\r\n\tmargin-left: 5px;\r\n\tmargin-right: 5px;\r\n}\r\n\r\nbutton {\r\n\t/* remove default button styles */\r\n\tmargin: 0;\r\n\tbackground-color: transparent;\r\n\ttext-align: inherit;\r\n\tfont: inherit;\r\n\tappearance: none;\r\n\tborder-style: none;\r\n\t/* default look */\r\n\tpadding: 1rem 2.5rem 1rem 2.5rem;\r\n\tborder-radius: 0.5rem;\r\n\tbackground: rgb(105, 145, 163);\r\n\tcolor: white;\r\n\tcursor: pointer;\r\n\tfont-size: 1.5rem;\r\n}\r\n\r\ninput {\r\n\tpadding: 10px;\r\n\tfont-size: 16px;\r\n\tmargin: 10px 0;\r\n\twidth: 100%;\r\n\tborder: 1px solid #ccc;\r\n\tborder-radius: 4px;\r\n}\r\n\r\n@font-face {\r\n\tfont-family: 'LibreBodoniBold';\r\n\tfont-weight: normal;\r\n\tsrc: url('../public/fonts/LibreBodoni-Bold.ttf') format('truetype');\r\n\tfont-style: normal;\r\n\tfont-display: swap;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
